import getUserCHatDetail from '.';
import {useQuery} from 'react-query';

const useGetUserChatDetail = (guid?: string) => {
  const {data, isLoading, refetch} = useQuery({
    queryKey: ['ChatDetail', guid],
    queryFn: () => getUserCHatDetail(guid),
    enabled: guid ? true : false,
  });

  return {
    userChatDetailData: data,
    userChatDetailIsLoading: isLoading,
    refetch,
  };
};

export default useGetUserChatDetail;
